import { Injectable } from '@angular/core';

import { destinosStorage } from "./data.service";
import { AutoCompleteService } from "../../../shared/components/autocomplete/autocomplete.service";

@Injectable()
export class DestinoService {

    constructor(
        private _autocompleteService: AutoCompleteService
    ) { }

    //session
    setSessionStorage(item: any) {
        let object: string = JSON.stringify(item);
        sessionStorage.setItem(destinosStorage + '-new', object);
    }

    getSessionStorage() {
        let item: string = sessionStorage.getItem(destinosStorage + "-new");
        return JSON.parse(item);
    }

    clearSessionStorage() {
        sessionStorage.removeItem(destinosStorage + "-new");
    }

    returnToOtherForm(otherForm: string, Response: any) {
        //     let otherFormObject: any;

        // if(Response) {
        //     if (otherForm === destinosTrajetosStorage) {
        //         otherFormObject = this._destinoTrajetoService.getSessionStorage();
        //         otherFormObject.destino = Response;
        //         this._destinoTrajetoService.setSessionStorage(otherFormObject);
        //     }
        // }
        //
        // this._autocompleteService.clearSessionStorage(destinosTrajetosStorage);
        //
        // if (otherForm === destinosTrajetosStorage) {
        //     otherFormObject = this._destinoTrajetoService.getSessionStorage();
        //     if (otherFormObject.id) {
        //         this._destinoTrajetoNavigationService.goToEdit(otherFormObject.id);
        //     } else {
        //         this._destinoTrajetoNavigationService.goToNew();
        //     }
        // }
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/destinos/shared/destino.service.ts
 **/